import { action } from 'satcheljs';
import type HeaderCharmType from '../store/schema/HeaderCharmType';

export interface DeactivateCharmActionMessage {
    charm: HeaderCharmType;
}

const defaultExport: (charm: HeaderCharmType) => DeactivateCharmActionMessage = action(
    'DEACTIVATE_CHARM',
    function deactivateCharm(charm: HeaderCharmType): DeactivateCharmActionMessage {
        return {
            charm,
        };
    }
);
export default defaultExport;
